export default __webpack_public_path__ + "static/bncff-9988d5c475048aa13fa9b2b0429470ca.mp4";